//To Do : We will remove it after Topbar menu in Reapit element fixed
import { css } from '@linaria/core'

export const elInlineFlex = css`
  display: inline-flex;
`

export const elMobileMenuOverflowYScroll = css`
  overflow-y: scroll;
  max-height: 93vh;
  scrollbar-width: none;
`
